export const feedingOptionsEnum = {
  BreakfastLunchOther: 0,
  Supper: 1,
};

export const feedingOptions = [
  {
    value: feedingOptionsEnum.BreakfastLunchOther,
    label: 'Breakfast / Lunch / Other',
  },
  { value: feedingOptionsEnum.Supper, label: 'Supper' },
];



// WEBPACK FOOTER //
// ./src/pages/uncloseday/helpers/index.js